import Server from '../../api/server'
import {
  APT_THREAT_INTEL_ROUTE,
  GENERATE_PRESIGNED_URL_ROUTE,
  MALWARE_THREAT_INTEL_ROUTE,
  NETWORK_THREAT_INTEL_ROUTE,
} from '../../strings/api-consts'
import { CustomThunkDispatch } from '../../types/UserTypes'
import { setAptData, setMalwareData, setNetworkData } from './adversaries.slice'
import { AptIntel, MalwareIntel } from '../../types/StatTypes'
import { reportErrorToDatadog } from '../../utils/error-logging'

const server = new Server()

const fetchPresignedUrl = (bucket: string, fileName: string) => async (dispatch: CustomThunkDispatch) => {
  return server
    .post(GENERATE_PRESIGNED_URL_ROUTE, { bucket: bucket, fileName: fileName }, dispatch)
    .then((res) => {
      if (!res) {
        throw new Error('Response is undefined')
      }
      return res.json()
    })
    .then((response: { url: string }) => {
      return response.url
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      return null
    })
}

export const downloadReportPdf = (bucket: string, fileName: string) => async (dispatch: CustomThunkDispatch) => {
  const presignedUrl = await fetchPresignedUrl(bucket, fileName)(dispatch)

  if (!presignedUrl) {
    return false
  }

  const link = document.createElement('a')
  link.href = presignedUrl
  link.download = fileName
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return true
}

export const fetchThreatIntelMalware = () => async (dispatch: CustomThunkDispatch) => {
  return server
    .get(MALWARE_THREAT_INTEL_ROUTE, dispatch)
    .then((malwareThreatIntel: MalwareIntel) => {
      dispatch(setMalwareData(malwareThreatIntel))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      dispatch(setMalwareData(undefined))
    })
}

export const fetchThreatIntelApt = () => async (dispatch: CustomThunkDispatch) => {
  return server
    .get(APT_THREAT_INTEL_ROUTE, dispatch)
    .then((aptThreatIntel: AptIntel) => {
      dispatch(setAptData(aptThreatIntel))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      dispatch(setAptData(undefined))
    })
}

export const fetchThreatIntelNetwork = () => async (dispatch: CustomThunkDispatch) => {
  return server
    .get(NETWORK_THREAT_INTEL_ROUTE, dispatch)
    .then((aptThreatIntel: AptIntel) => {
      dispatch(setNetworkData(aptThreatIntel))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      dispatch(setNetworkData(undefined))
    })
}
